import Head from 'next/head';
import * as React from 'react';
import MainError from './_error';
import { useTheme } from '@/themes';
import { GetServerSideProps } from 'next';
import { SemanticCard } from '@/styles/base';
import { Text } from '@zopauk/react-components';
import { withSession } from '@zopauk/nextjs-auth';
import { useSearchParams } from 'next/navigation';
import { pageTitles } from '@/utils/copy/page-titles';
import { setUserId, logEvent } from '@/utils/analytics';
import { colors } from '@/themes/jl-money/constants/colors';
import { FullPageLayout } from '@/components/FullPageLayout';
import { useApplications } from '@/utils/queries/useApplications';
import amplitudeEvents from '@/utils/amplitudeEvents.json' with { type: 'json' };
import { handleOriginationsWebRollout } from '@/utils/handleOriginationsWebRollout';

// TODO: Align with Rezza2 re: not needing a specialist component for this
export const MainCobrandedLegalCopy = () => (
  <div>
    <Text color={colors.jlMoneyGreyDark} className="mb-4" size="small" as="p">
      Zopa Bank Limited is authorised by the Prudential Regulation Authority and regulated by the Financial Conduct
      Authority and the Prudential Regulation Authority, and entered on the Financial Services Register (800542). Zopa
      Bank Limited (10627575) is incorporated in England &amp; Wales and has its registered office at: Zopa Bank, Level
      12, 20 Water Street, Canary Wharf, London E14 5GX.
    </Text>
    <Text color={colors.jlMoneyGreyDark} className="mb-4" size="small" as="p">
      © Zopa Bank Limited {new Date().getFullYear()} All rights reserved. 'Zopa' is a trademark of Zopa Bank Limited.
    </Text>
    <Text color={colors.jlMoneyGreyDark} className="mb-4" size="small" as="p">
      Zopa is a member of Cifas – the UK’s leading anti-fraud association, and we are registered with the Information
      Commission’s Office (ZA275984).
    </Text>
    <Text color={colors.jlMoneyGreyDark} className="mb-4" size="small" as="p">
      John Lewis Finance Limited introduces personal loans provided by Zopa Bank.
    </Text>
    <Text color={colors.jlMoneyGreyDark} className="mb-4" size="small" as="p">
      John Lewis Finance Limited is a credit broker (firm reference number: 1018169). Registered office: 1 Drummond
      Gate, Pimlico, London SW1V 2QQ. Registered in England and Wales (company number: 15785347). John Lewis Finance
      Limited is a credit broker, not a lender.
    </Text>
    <Text color={colors.jlMoneyGreyDark} className="mb-4" size="small" as="p">
      Credit is provided by Zopa Bank. Registered office: Zopa Bank, Level 12, 20 Water Street, Canary Wharf, London E14
      5GX. Zopa Bank Limited is authorised by the Prudential Regulation Authority and regulated by the Financial Conduct
      Authority and the Prudential Regulation Authority (firm reference number: 800542).
    </Text>
  </div>
);

const Cancelled = () => {
  const { partnerName } = useTheme();
  const searchParams = useSearchParams();
  const { error, data } = useApplications(searchParams?.get('publicId'));

  React.useEffect(() => {
    if (data) {
      if (data.zopaMemberId) {
        setUserId(data.zopaMemberId);
      }
      logEvent(amplitudeEvents.QUOTE_CANCELLED, { applicationId: data.id });
    }
  }, [data]);

  if (error) {
    return <MainError statusCode={500} />;
  }

  return (
    <>
      <Head>{pageTitles.cancelled}</Head>
      <div className="co-branded">
        <FullPageLayout
          mainCobrandedLegalCopy={partnerName === 'jl-money' ? <MainCobrandedLegalCopy /> : null}
          title="Sorry, something went wrong"
          isCobranded={true}
        >
          <div className="co-branded">
            <SemanticCard className="p-8">
              <Text className="pl-2" as="p">
                We encountered a technical problem whilst processing your application. Please try again later. Don't
                worry, this hasn't impacted your credit file.
              </Text>
            </SemanticCard>
          </div>
        </FullPageLayout>
      </div>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = handleOriginationsWebRollout('/loans/quotation/cancelled');

export default withSession(Cancelled, {
  forceLogin: false,
});
